const triggerSendStateFactor = (country ,lang , sessionId , externalRefId,stateToken , deviceType) => {
    lang = getLocalLanguage(lang)
     const Headers = {
         "Content-Type": `application/json`,
           "x-wu-correlationId": sessionId,
           "x-wu-externalRefId": externalRefId,
           "WuCountryCode": country,
           "WuLanguageCode": lang,
           "x-wu-operationName": "sendStateFactor",
           "Accept-Language": `${lang}-${country}`,
           "WuCountryCode": country,
           "WuLanguageCode": lang,
           "x-wu-sessionId": sessionId,
           "DEVICEDETAILS":"Browser",
           "SOURCE":"ExpPlatform",
           "canary":"false",
           "isrrenabled":"false",
           "platform":"nextgen",
           "DISPLAYSYSTEM":"Web",
           "accept": `application/json`,
       };
 
     const sendStateFactorBody = 
         {
             "deviceAuthType": deviceType,
             "stateToken": stateToken
         }
     
 
     const requestOptions = {
         method: "POST",
         body: JSON.stringify(sendStateFactorBody),
         headers: Headers
     };
 
     try {
         return fetchApiWu('/auth/v2/state/factor/send', requestOptions, 'sendStateFactor')
             .then((response) => {
                return response ;     
             })
     } catch(e) {
         console.log(e);
         return "error"
         
     }
     
 };

 window.queryData.triggerSendStateFactor = triggerSendStateFactor; 